import { render, staticRenderFns } from "./data-tree-node.vue?vue&type=template&id=25a8909e&scoped=true"
import script from "./data-tree-node.vue?vue&type=script&lang=ts"
export * from "./data-tree-node.vue?vue&type=script&lang=ts"
import style0 from "./data-tree-node.vue?vue&type=style&index=0&id=25a8909e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8909e",
  null
  
)

export default component.exports